<template>
  <v-app>
    <NuxtLayout>
      <NuxtLoadingIndicator
        class="bg-primary"
        :color="false"
      />
      <NuxtPage />
    </NuxtLayout>
  </v-app>
</template>

<script setup lang="ts">
useCanonical()
</script>
